/**
 * @description: 是否为附身登录
 * @return {*}
 */
export const isOperation = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    return userInfo?.impersonate === 1
}